<template>
    <v-row justify="center">
        <v-dialog max-width="500px" persistent v-model="showPopup.show">
            <v-card>
                <v-card-title class="blue">
                    <span class="headline">Kunden hinzufügen</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-form ref="form">
                            <v-row>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field :rules="inputRules" class="my-0 py-0" label="Email" required
                                                  v-model="customer.Email"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Ansprechpartner" required
                                                  v-model="customer.AP"></v-text-field>
                                </v-col>

                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Firma" required
                                                  v-model="customer.Firma"></v-text-field>
                                </v-col>


                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Straße" required
                                                  v-model="customer.Strasse"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="PLZ" required
                                                  v-model="customer.PLZ"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Ort" required
                                                  v-model="customer.Ort"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Land"
                                                  v-model="customer.Land"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Telefon" required
                                                  v-model="customer.Telefon"></v-text-field>
                                </v-col>
                                <v-col class="my-0 py-0" cols="12">
                                    <v-text-field class="my-0 py-0" label="Kommentar" required
                                                  v-model="customer.Kommentar"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="showPopup.show = false" color="blue darken-1" text>Schließen</v-btn>
                    <v-btn :disabled="loading" :loading="loading" @click="submit" color="green darken-1" text>
                        Speichern
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import moment from 'moment'
    import {HTTP} from "../http";
    import {EventBus} from "../eventbus";


    export default {
        props: {
            showPopup: Object,
        },
        data() {
            return {
                customer: {
                    Land: "Deutschland",
                },

                inputRules: [
                    v => !!v || 'Darf nicht leer sein'
                ],
                loading: false,

            }
        },
        methods: {
            submit() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    HTTP.post("api/Customer", this.customer).then(() => {
                        this.loading = false;
                        EventBus.$emit('reload');
                        this.showPopup.show = false;
                    }).catch(() => {
                        this.loading = false;
                    })

                }

            }
        },
        computed: {
            formattedDate() {
                return this.due ? moment(this.due).format('DD MMM YYYY') : ''
            }
        }
    }
</script>
